unable to read source [project]/node_modules/superjson/src/util.ts